import { getSonarByCurrentAndBaseline } from '../reducers/sonar';

/**
 * hasBeenLoaded check for sonar data fetch api call.
 * This function breaks our normal hasBeenLoaded pattern for apiCalls.
 * Ideally, this is declared in-line when hitting actions/api/apiCall.
 * This was done in order to enable explicit testing of the hasBeenLoaded function,
 * as jest was having issues with the dispatching of the apiCall when running
 * tests.
 * TODO Refactor to adhere to normal patterning.
 * @param {*} state The state to check data for.
 * @param {*} baselineBuildId The baseline build id for the sonar call.
 * @param {*} currentBuildId The current build id for the sonar call.
 */
export const hasBeenLoaded = (state, baselineBuildId, currentBuildId) => {
  const responses = getSonarByCurrentAndBaseline(state);
  return responses[currentBuildId] && responses[currentBuildId][baselineBuildId] ?
    responses[currentBuildId][baselineBuildId] : false;
};


// WEBPACK FOOTER //
// src/helpers/sonar.js